import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "../../shared/filters/types/filter";
import { getSelectedFilterValue } from "../../shared/filters/utils/filter/filtervalue";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";

const SORT_BY_ID = "sortedBy";

const gridCodeSortableTaskTypes = ["productIssue", "PQR", "testbuy"];
const addonGridCodeSortableTaskTypes = ["pickAndRefill", "refill"];

export function useSortByFilter(filterValues: FilterValue[]): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: SORT_BY_ID,
    value: "createdAtDesc",
  };
  const selected = getSelectedFilterValue(
    SORT_BY_ID,
    filterValues,
    defaultValue
  );

  const enableSortByGridCode = filterValues.some(
    (filter) =>
      filter.filterId === TASK_TYPE_ID &&
      gridCodeSortableTaskTypes.includes(filter.value as string)
  );

  const enableAddonSortByGridCode = filterValues.some(
    (filter) =>
      filter.filterId === TASK_TYPE_ID &&
      addonGridCodeSortableTaskTypes.includes(filter.value as string)
  );

  const options = [
    { value: "createdAtDesc", title: t("newestFirstString") },
    { value: "createdAtAsc", title: t("oldestFirstString") },
    enableSortByGridCode && {
      value: "gridCodeDesc",
      title: t("gridCodeDescendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
    enableSortByGridCode && {
      value: "gridCodeAsc",
      title: t("gridCodeAscendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
    enableAddonSortByGridCode && {
      value: "pickupGridCodeDesc",
      title: t("pickupGridCodeDescendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
    enableAddonSortByGridCode && {
      value: "pickupGridCodeAsc",
      title: t("pickupGridCodeAscendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
    enableAddonSortByGridCode && {
      value: "refillGridCodeDesc",
      title: t("refillGridCodeDescendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
    enableAddonSortByGridCode && {
      value: "refillGridCodeAsc",
      title: t("refillGridCodeAscendingString"),
      dependsOnFilterId: TASK_TYPE_ID,
    },
  ].filter(Boolean) as { value: string; title: string }[];

  const selectedOption = options.find(
    (option) => option.value === selected.value
  )!;

  return {
    inputType: InputType.Select,
    filterType: FilterType.Sort,
    id: SORT_BY_ID,
    title: t("sortByFilterTitleString", { option: selectedOption.title }),
    options,
    enabled: true,
    defaultValue,
  };
}
